module.exports = __webpack_public_path__ + "img/zambia.5f43b39.webp";